import { editorType } from "./index"
import { editorSections as CCPSections } from "./CCPEditor"
import { editorSections as HSSections } from "./HazardStepsEditor"
import { editorSections as HISections } from "./HazardsInputsEditor"
    
const validateTitle = (name) => {
    const titleRegex = /[A-Z][A-Za-z0-9]{2,4}-[A-Z]-[A-Za-z0-9]{2,4} (\w+\s)*\w+/
    if(titleRegex.test(name)){
        return true
    }
    else {
        alert("Title's form must be Aaaa-A-a0 + free format")
        return false
    }
}

export const validate = (sopState, roles, name, doctype) => {
    var sop = { ...sopState }
    sop['type'] = roles.includes('admin') ? 'approved' : 'proposal'
    sop['writer'] = name
    sop['status'] = sop.type
    sop['doctype'] = doctype 
    const tags = ['AR','LOC','DOC','PR','ING', 'PRS', 'EQU','PAC']
    let res = {empty:[], filled:[], tags:false, newSop:sop}
    if(!sop.biological_hazard){
        if( !sop.masterDoc || sop.masterDoc == '' || sop.masterDoc.length<2)
            res.empty.push('masterDoc')
        if( !sop.typeOfDoc || sop.typeOfDoc == '' || sop.typeOfDoc.length<1)
            res.empty.push('typeOfDoc')
        if( !sop.documentKey || sop.documentKey == '' || sop.documentKey.length<2)
            res.empty.push('documentKey')
        if( !sop.name || sop.name == '' || sop.name.length<1)
            res.empty.push('name')
    }
    switch(doctype){
        case editorType.hi:
            if(sop.hasOwnProperty('title')){
                if( sop.title != '' )
                    res.filled.push('Title')
                else
                    res.empty.push('Title')
            }
            else
                res.empty.push('Title')
            Object.keys(HISections).forEach( section => {
                if(sop.hasOwnProperty(section)){
                    if( (sop[section] !== '' && sop[section] !== "<p></p>" && sop[section] !== "<p></p>\n") || section == "biological_hazard" || section == "bh_measure" || section == "chemical_hazard" || section == "ch_measure" || section == "physical_hazard" || section == "ph_measure" )
                        res.filled.push(HISections[section])
                    else
                        res.empty.push(HISections[section])
                }
                else
                    res.empty.push(HISections[section])
            })
            return res
        case editorType.hs:
            if(sop.hasOwnProperty('title')){
                if( sop.title != '' )
                    res.filled.push('Title')
                else
                    res.empty.push('Title')
            }
            else
                res.empty.push('Title')
            Object.keys(HSSections).forEach( section => {
                if(sop.hasOwnProperty(section)){
                    if( section == "bh_rlto" || section == "ch_rlto" || section == "ph_rlto" || section == "ccp" ){
                        res.filled.push(HSSections[section])
                    } 
                    else {
                        if( (sop[section] !== '' && sop[section] !== "<p></p>" && sop[section] !== "<p></p>\n") || section == "description" || section == "biological_hazard" || section == "bh_rlto" || section == "bh_justification" || section == "chemical_hazard" || section == "ch_rlto"  || section == "ch_justification" || section == "physical_hazard" || section == "ph_rlto" || section == "ph_justification" || section == "measures" || section == "ccp" || section == "bh_rlto" )
                            res.filled.push(HSSections[section])
                        else
                            res.empty.push(HSSections[section])
                    }
                }
                else
                    res.empty.push(HSSections[section])
            })
            return res
        case editorType.ccp:
            if(sop.hasOwnProperty('title')){
                if( sop.title !== '' )
                    res.filled.push('Title')
                else
                    res.empty.push('Title')
            }
            else
                res.empty.push('Title')
            Object.keys(CCPSections).forEach( section => {              
                if(sop.hasOwnProperty(section)){
                    if( (sop[section] !== '' && sop[section] !== "<p></p>" && sop[section] !== "<p></p>\n") || section=="hazards" || section=="cl" || section=="monitoring_what" || section=="monitoring_how" || section=="monitoring_when" || section=="monitoring_who" || section=="corrective_actions" || section=="verification" || section=="records" )
                        res.filled.push(CCPSections[section])
                    else
                        res.empty.push(CCPSections[section])
                }
                else
                    res.empty.push(CCPSections[section])
            })
            return res
        case editorType.doc:
            sop.hasOwnProperty('title') ?
                ((sop.title !=='' && sop.title !== '<p></p>') && validateTitle(sop.title)) ? res.filled.push('Title'):res.empty.push('Title')
                :res.empty.push('Title')
            sop.hasOwnProperty('text') ?
                sop.text !==''  && sop.text !== '<p></p>'  ? res.filled.push('Text'):res.empty.push('Text')
                :res.empty.push('Text')
            sop.hasOwnProperty('records') ?
                sop.records !== '' && sop.records !== '<p></p>\n' ? res.filled.push('Records') : res.empty.push('Records')
                : res.empty.push('Records')
            return res
        case editorType.sop:
            sop.hasOwnProperty('title') ?
                ((sop.title !=='' && sop.title !== '<p></p>') && validateTitle(sop.title)) ? res.filled.push('Title'):res.empty.push('Title')
                :res.empty.push('Title')
            sop.hasOwnProperty('records') ?
                sop.records !== '' && sop.records !== '<p></p>\n' ? res.filled.push('Records') : res.empty.push('Records')
                : res.empty.push('Records')
            sop.hasOwnProperty('purposeandintroduction') ?
                sop.purposeandintroduction !=='' && sop.purposeandintroduction !== '<p></p>' ? res.filled.push('Purpose and introduction'): res.empty.push('Purpose and introduction')
                : res.empty.push('Purpose and introduction')
            sop.hasOwnProperty('verificationandrecordkeeping') ?
                sop.verificationandrecordkeeping !=='' && sop.verificationandrecordkeeping !== '<p></p>' ? res.filled.push('Verification and record keeping'): res.empty.push('Verification and record keeping')
                : res.empty.push('Verification and record keeping')
            sop.hasOwnProperty('monitoring') ?
                sop.monitoring !=='' && sop.monitoring !== '<p></p>' ? res.filled.push('Monitoring'): res.empty.push('Monitoring')
                : res.empty.push('Monitoring')
            sop.hasOwnProperty('criteriaandinstructions') ?
                sop.criteriaandinstructions !=='' && sop.criteriaandinstructions !== '<p></p>' ? res.filled.push('Criteria and instructions'): res.empty.push('Criteria and instructions')
                : res.empty.push('Criteria and instructions')
            sop.hasOwnProperty('responsibilities') ?
                sop.responsibilities !=='' && sop.responsibilities !== '<p></p>' ? res.filled.push('Responsibilities'): res.empty.push('Responsibilities')
                : res.empty.push('Responsibilities')
            
            sop.hasOwnProperty('correctiveactions') ?
                sop.correctiveactions !=='' && sop.correctiveactions !== '<p></p>' ? res.filled.push('Corrective actions'): res.empty.push('Corrective actions')
                : res.empty.push('Corrective actions')
            tags.forEach(x=>{
                if(sop.humantags.hasOwnProperty(x)){
                    (sop.humantags[x].length > 0 && sop.humantags[x][0] !== '') ? res.filled.push(x) : res.empty.push(x)
                } else {
                    res.tags = true
                }
            })
            return res

    }
}